import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {RrcEp10WasteManifest, RrcEp10WasteManifestEntity} from "../../../model/rrc/rrc-ep10-waste-manifest";

export interface RrcEp10WasteManifestSelectorProps {

}

export const rrcEp10WasteManifestsSelector = () => createSelector(
  [getUseQueryResultData<RrcEp10WasteManifest[]>],
  (data) => {
    return selectRrcEp10WasteManifestsAndTransform(
      data ?? [], {}
    );
  }
);

export const rrcEp10WasteManifestSelector = () => createSelector(
  [getUseQueryResultData<RrcEp10WasteManifest>],
  (data) => {
    return data ? transformRrcEp10WasteManifest(data) : undefined;
  }
);

export const selectRrcEp10WasteManifests = (values?: RrcEp10WasteManifest[], selector?: RrcEp10WasteManifestSelectorProps): RrcEp10WasteManifest[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformRrcEp10WasteManifest = (value: RrcEp10WasteManifest): RrcEp10WasteManifestEntity => {
  return RrcEp10WasteManifestEntity.from(value)
}

export const selectRrcEp10WasteManifestsAndTransform = (values?: RrcEp10WasteManifest[], selector?: RrcEp10WasteManifestSelectorProps): RrcEp10WasteManifestEntity[] => {
  const selected = selectRrcEp10WasteManifests(values, selector);
  return selected.map(transformRrcEp10WasteManifest);
};
